import React from 'react';
import { ComplianceAlert } from '../taxComplianceTypes';
import styles from './ComplianceAlerts.module.css';

interface ComplianceAlertsProps {
  alerts: ComplianceAlert[];
}

export const ComplianceAlerts: React.FC<ComplianceAlertsProps> = ({ alerts }) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Compliance Alerts</h3>
      <div className={styles.list}>
        {alerts.map((alert, idx) => (
          <div
            key={idx}
            className={styles.alertItem}
            style={{ background: alert.bg, borderColor: alert.borderColor }}
          >
            <p className={styles.alertTitle} style={{ color: alert.titleColor }}>
              {alert.title}
            </p>
            <p className={styles.alertSubtext}>{alert.subtext}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
